<template>
  <button
    :disabled="loading || disabled"
    @click="$emit('click')"
    :style="btnStyles"
    class="btn btn-blue btn--loader btn-component">
    <slot></slot>
    <transition name="fade">
      <slot name="loader" v-if="loading">
        <span
          class="loader-wrapper"
          :style="btnStyles">
          &nbsp;<i class="fas fa-spinner fa-spin"></i>
        </span>
      </slot>
    </transition>
  </button>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'buttonLoader',
  components: {},
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    color: {
      type: String,
      default: () => '#FFFFFF',
    },
    background: {
      type: String,
      default: () => '#1D89BF',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    btnStyles() {
      return {
        background: this.btnColor,
        color: this.color,
      };
    },
    btnColor() {
      return this.disabled ? '#a09f9f' : this.background;
    },
  },
});
</script>

<style lang="scss">
  .btn-component {
    position: relative;

    .loader-wrapper {
      position: absolute;
      z-index: 5;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
